goog.provide('el8.util.amplitude.orderHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Prep data and fire 'complete lab' event to Amplitude
 * This is currently called from the following (3) places in order/lab.js:
 * addDiscardButton, _saveAndClose, _saveAsDraft
 * @param order
 * @param action
 * @param error_msg
 */
el8.util.amplitude.logCompleteOrder = function(order, action, error_msg) {
  // Allow time for order to be updated in legacy store before accessing properties,
  // otherwise analytics data will be referencing property values before they're updated
  // by the server (e.g. signDate)
  setTimeout(function(){
      if (!order) {  // We're seeing a lot of exceptions because order is null -- log this
          el8.util.amplitude.logEvent(
            'complete lab', {'action': action, 'error': error_msg, 'lab vendor': ''}
            );
          return;
      }
      var ampData = {
          'action': action,
          'bill type': order.getBillType(),
          'stat': order.getStatMethod(),
          'patient condition': order.getFastingMethod(),
          'number of tests': order.getTestIds().length,
          'number of diagnoses': order.getIcd10Ids().length,
          'error': error_msg,
          'specimen collection type': order.isIsInHouse() ? 'In-house draw' : 'Any Site',
          'specimen collection date and time set': Boolean(order.getCollectionDatetime())
      };
      // The following are properties where we only care to record IF they were filled out,
      // not WHAT they were filled out with.
      // We also do not want to send them as false if they are not filled out, since
      // that will set an event property in amplitude as false (we want the property
      // not to be set at all)
      var vendorName = "";
      if (order.getVendorId()) {
          vendorName = el8.data.labVendors.getById(order.getVendorId()).getDisplayName();
          ampData['lab vendor'] = vendorName;
      } else if (order.getTestCenterCompanyId()) {
          vendorName = el8.data.ancillaryCompanies.lab.getById(order.getTestCenterCompanyId()).getName();
          ampData['lab vendor'] = vendorName;
      }
      if (order.getStandingOrderFrequency()) {ampData['standing order'] = true;}
      if (order.getStandingOrderEndDate()) {ampData['standing order end date'] = true;}
      if (order.getDateForTest()) {ampData['test on date'] = true;}
      if (order.getReminder()) {ampData['reminder'] = true;}
      if (order._confidential) {ampData['confidential'] = true;}
      if (order.getFollowUpMethod()){ampData['notify patient'] = true;}
      if (order.getTestCenterNotes()){ampData['lab instruction'] = true;}
      if (order.getCcIds().length){ampData['copy'] = true;}
      if (order._showDualCoding) {ampData['dual codes'] = true;}

      // If the order was signed, calculate the time in seconds that it took from 
      // when it was originally created to when it was signed off
      if (order.rawData.signDate) {
        var createDatetime = new Date(order.rawData.createDate);
        var signDatetime = new Date(order.rawData.signDate);
        ampData['time from order creation to sign off'] = (signDatetime.getTime() - createDatetime.getTime()) / 1000;
      }

      el8.util.amplitude.logEvent('complete lab', ampData);
    }, 300);
};

/**
 * Amplitude logging for setting a order reminder for an order
 * 
 * @param {string} source - the order the reminder is set from
 * Theres a check for generic orders and converting sleep order to order
 */
el8.util.amplitude.logSetOrderReminder = function(source) {
    var sleepLabel =  el8.app.settings.genericOrder().getLabel('order', source);
    el8.util.amplitude.logEvent('set order reminder', {'source': (source === 'sleep order' ? sleepLabel : source)});
};

/**
 * Amplitude logging for order reminder actions, fulfilling or canceling
 * 
 * @param {string} action - the selected action 
 */
el8.util.amplitude.logOrderReminder = function(action) {
    el8.util.amplitude.logEvent('order reminder', {'action': action});
};

/**
 * Amplitude logging for remind later actions with source
 * 
 * @param {string} source - the order the reminder is set from
 * Theres a check for generic orders and converting sleep order to order
 */
el8.util.amplitude.logRemindLater = function(source) {
    var sleepLabel =  el8.app.settings.genericOrder().getLabel('order', source);
    el8.util.amplitude.logEvent('remind later', {'source': (source === 'SleepOrder' ? sleepLabel  : source)});
};

/**
 * Amplitude logging to update remind later to see the chosen action, date changed and assignee changed
 * 
 * @param {string} action - the action chosen, save or discard
 * @param {boolean} changedDate - whether date was changed or not, not included when discarded
 * @param {boolean} changedAssignee - whether assignee was changed or not, not included when discarded
 */
el8.util.amplitude.logUpdateRemindLater = function(action, changedDate, changedAssignee) {
    el8.util.amplitude.logEvent('update remind later', {'action': action, 'change date': changedDate, 'change assignee': changedAssignee});
}

/**
 * Amplitude logging for the changing Order Status action, order source and type
 * 
 * @param {string} action - the selected action 
 * @param {string} source - the order the reminder is set from
 * @param {string} orderType - the type of order that was changed
 * Theres a check for generic orders and converting sleep order to order
 */
el8.util.amplitude.logChangeOrderStatus = function(action, source, orderType) {
    var sleepLabel =  el8.app.settings.genericOrder().getLabel('order', source);
    el8.util.amplitude.logEvent('change order status', {'action': action, 'source': source, 'type': (orderType === 'SleepOrder' ? sleepLabel : orderType)});
};

/**
 * Amplitude logging for when the order status is fulfilled
 * 
 * @param {string} action - for when an item is attached or cancel
 */
el8.util.amplitude.logUpdateStatusFulfilled = function(action) {
    el8.util.amplitude.logEvent('update order status to fulfilled', {'action': action});
}

/**
 * Amplitude logging for when the order status is canceled
 * 
 * @param {string} action - for marking as canceled or the action is discarded
 * @param {boolean} cancelReason - a boolean for whether a reason for cancel is included
 */
el8.util.amplitude.logUpdateStatusCanceled = function(action, cancelReason) {
    el8.util.amplitude.logEvent('update order status to canceled', {'action': action, 'cancel reason': cancelReason});
}

/**
 * Amplitude logging for when the mark fulfilled on report dialog
 * 
 * @param {string} orderType - the type of order that is being fulfilled
 * Theres a check for generic orders and converting sleep order to order
 */
el8.util.amplitude.logMarkFulfilled = function(orderType) {
    var sleepLabel =  el8.app.settings.genericOrder().getLabel('order', orderType);
    el8.util.amplitude.logEvent('mark fulfilled', {'source': (orderType === 'SleepOrder' ? sleepLabel : orderType)});
}

/**
 * Amplitude logging for when the user clears the specimen collection
 * date and time in the lab order form
 */
el8.util.amplitude.logSpecimenCollectionCleared = function() {
  el8.util.amplitude.logEvent('specimen collection cleared');
}

/**
 * Amplitude logging for when the user clicks the various Actions menu 
 * items for documenting, editing, and deleting specimen collections
 * 
 * @param {string} action - name of the action item
 * @param {string} source - the source from which the action item was clicked
 */
el8.util.amplitude.logLabOrderActions = function(action, source) {
  var ampData = {};
  ampData[action] = source === 'report dialog' ? 'report view actions' : source;
  el8.util.amplitude.logEvent('lab order actions', ampData);
}
